(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.documentElement;
    const announcement = document.querySelector('[data-announcement]');
    if (announcement && !announcement.dataset.positionInitialized) {
      announcement.dataset.positionInitialized = 'true';
      const syncAnnouncementOffset = () => {
        const height = announcement.hidden || announcement.classList.contains('is-scroll-hidden') ? 0 : Math.ceil(announcement.getBoundingClientRect().height);
        root.style.setProperty('--ptc-announcement-offset', `${height}px`);
      };
      const resizeObserver = new ResizeObserver(syncAnnouncementOffset);
      const visibilityObserver = new MutationObserver(syncAnnouncementOffset);
      resizeObserver.observe(announcement);
      visibilityObserver.observe(announcement, { attributes: true, attributeFilter: ['hidden', 'class'] });
      let scrollTicking = false;
      const syncScrollVisibility = () => {
        scrollTicking = false;
        announcement.classList.toggle('is-scroll-hidden', window.scrollY > 24);
      };
      window.addEventListener('scroll', () => {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(syncScrollVisibility);
      }, { passive: true });
      window.addEventListener('load', syncAnnouncementOffset, { once: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(announcement)) return;
        resizeObserver.disconnect();
        visibilityObserver.disconnect();
        root.style.removeProperty('--ptc-announcement-offset');
      });
      syncScrollVisibility();
      syncAnnouncementOffset();
    }

    document.querySelectorAll('[data-countdown]').forEach((timer) => {
      if (timer.dataset.initialized) return;
      timer.dataset.initialized = 'true';
      const source = timer.dataset.deadline.trim();
      const target = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(source) ? source : `${source}-06:00`).getTime();
      const bar = timer.closest('[data-announcement]');
      let intervalId;
      const update = () => {
        const remaining = target - Date.now();
        if (!Number.isFinite(target) || remaining <= 0) {
          window.clearInterval(intervalId);
          if (bar?.dataset.hideWhenExpired === 'true') bar.hidden = true;
          else timer.hidden = true;
          return false;
        }
        const totalSeconds = Math.floor(remaining / 1000);
        const values = { days: Math.floor(totalSeconds / 86400), hours: Math.floor((totalSeconds % 86400) / 3600), minutes: Math.floor((totalSeconds % 3600) / 60), seconds: totalSeconds % 60 };
        Object.entries(values).forEach(([key, value]) => {
          const node = timer.querySelector(`[data-${key}]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        return true;
      };
      if (update()) intervalId = window.setInterval(update, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
